/****************************************************
 * Module Name:  addTingeModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import TingeProxy from "../../utility/proxy/manager/tingeProxy";
import Constants from "../../utility/constants";
import logo from '../../images/pansuriya.jpg'
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import SaveIcon from '@mui/icons-material/Save';

export default class AddTingeModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newtinge: this.props.editOperation ? this.props.sourceData.name : "",
      newtingefullname: this.props.editOperation
        ? this.props.sourceData.fullname
        : "",
      newdescription: this.props.editOperation
        ? this.props.sourceData.description
        : "",
      newwebref: this.props.editOperation ? this.props.sourceData.webref : "",

      showError: false,

      validateTingePresentSpinner: false,
      showValidationMessage: false,
      tingeAvailable: true,

      tingeValidationError: "",
      fullNameValidationError: "",
    };
  }

  handleSave = () => {
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      name: this.state.newtinge,
      fullname: this.state.newtingefullname,
      description: this.state.newdescription,
      webref: this.state.newwebref,
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateTingePresent = (tingeEntered) => {
    if (!tingeEntered || tingeEntered.trim() === "") return;

    this.setState({
      validateTingePresentSpinner: true,
    });

    TingeProxy.CheckTingeAvailable(tingeEntered, (response) => {
      //if we got response that means tinge is present at backend
      if (response) {
        //TingeName already present
        this.setState({
          validateTingePresentSpinner: false,
          showValidationMessage: true,
          tingeAvailable: false,
        });
      } else {
        //TingeName not available, so can be used
        this.setState({
          validateTingePresentSpinner: false,
          showValidationMessage: true,
          tingeAvailable: true,
        });
      }
    });
  };

  buttonDisable = () => {
    if (this.props.editOperation && this.state.newtingefullname.length === 0)
      return true;

    if (!this.props.editOperation)
      return (
        !this.state.showValidationMessage ||
        !this.state.tingeAvailable ||
        this.state.newtingefullname.length === 0
      );

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add tinge validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation ? "Edit Tinge" : "Add New Tinge"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  {this.props.editOperation && (
                    <tr>
                      <td>
                        <Form.Label>Tinge Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.sourceData.id}</Form.Label>
                      </td>
                    </tr>
                  )}
                  {this.props.editOperation && (
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <Form.Label>
                        Tinge <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    {this.props.editOperation ? (
                      <td>
                        <Form.Label>{this.state.newtinge}</Form.Label>
                      </td>
                    ) : (
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="Tinge (required)"
                          placeholder="Enter Tinge"
                          value={this.state.newtinge}
                          autoFocus
                          onBlur={(e) =>
                            this.validateTingePresent(this.state.newtinge)
                          }
                          onChange={(e) =>
                            this.setState({
                              newtinge: e.target.value,
                              showValidationMessage: false,
                              tingeValidationError: Utility.CheckIsPresent(
                                e.target.value
                              )
                                ? ""
                                : "Tinge Cannot be Empty",
                            })
                          }
                          helperText={this.state.tingeValidationError}
                          error={this.state.tingeValidationError.length > 0}
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      {this.state.validateTingePresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box>&nbsp;</Box>
                      ) : this.state.tingeAvailable ? (
                        <font color="green">Tinge available</font>
                      ) : (
                        <font color="red">Tinge not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Fullname <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Tinge Fullname (required)"
                        placeholder="Tinge Enter Fullname"
                        value={this.state.newtingefullname}
                        onChange={(e) =>
                          this.setState({
                            newtingefullname: e.target.value,
                            fullNameValidationError: Utility.CheckIsPresent(
                              e.target.value
                            )
                              ? ""
                              : "Tinge Fullname Cannot be Empty",
                          })
                        }
                        helperText={this.state.fullNameValidationError}
                        error={this.state.fullNameValidationError.length > 0}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Description</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Description"
                        placeholder="Enter Description"
                        value={this.state.newdescription}
                        onChange={(e) =>
                          this.setState({ newdescription: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Web Reference</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Web Reference"
                        placeholder="Enter Web Reference"
                        value={this.state.newwebref}
                        onChange={(e) =>
                          this.setState({ newwebref: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
